import { ComponentProps } from "react";

import AppContextValueProvider from "../../../App/Compositions/AppContextValueProvider";
import ObservedSchedulingLoader from "../Components/ObservedSchedulingLoader";
import ISchedulingLoaderProps from "../Types/ISchedulingLoaderProps";

const AppContextSchedulingLoader = AppContextValueProvider<
  ISchedulingLoaderProps,
  ComponentProps<typeof ObservedSchedulingLoader>
>({
  Component: ObservedSchedulingLoader,
  map: ({ bookingController, patient, reservation, router }) => ({
    bookingController,
    patientFirstName: patient.displayFirstName,
    reservation,
    router
  })
});

export default AppContextSchedulingLoader;
